const ALWAYS_EMPTY_OBJECT = Object.freeze({});

// TODO: move into src/utils/values
const asObject = value => (value === null || value === void 1 ? ALWAYS_EMPTY_OBJECT : value);

// noinspection JSUnusedGlobalSymbols
export default asObject;
